

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpModule, JsonpModule } from '@angular/http';

import {CheckboxModule,DialogModule,RadioButtonModule} from 'primeng/primeng';
import {DataTableModule,SharedModule} from 'primeng/primeng';
import {DataListModule} from 'primeng/primeng';
import {CalendarModule} from 'primeng/primeng';

import { FormsModule } from '@angular/forms';

import { AuthGuard } from '../service/auth-guard.service';


import { TranslateModule, TranslateLoader} from '@ngx-translate/core';

import { AFormTextComponent } from './aFormText/aFormText.component';
import { AFormTextareaComponent } from './aFormTextarea/aFormTextarea.component';
import { AFormYesNoComponent } from './aFormYesNo/aFormYesNo.component';
import { AFormPasswordComponent } from './aFormPassword/aFormPassword.component';
import { AFormEmailComponent } from './aFormEmail/aFormEmail.component';
import { AFormSelectComponent } from './aFormSelect/aFormSelect.component';
import { AFormSelectLangComponent } from './aFormSelectLang/aFormSelectLang.component';
import { AFormNumberComponent } from './aFormNumber/aFormNumber.component';
import { AFormIntegerComponent } from './aFormInteger/aFormInteger.component';
import { AFormPIntegerComponent } from './aFormPInteger/aFormPInteger.component';
import { AFormImgComponent } from './aFormImg/aFormImg.component';
import { AFormFileComponent } from './aFormFile/aFormFile.component';
import { AFormCurrencyComponent } from './aFormCurrency/aFormCurrency.component';
import { AFormDateComponent } from './aFormDate/aFormDate.component';
import { AFormRadioComponent } from './aFormRadio/aFormRadio.component';
import { AFormRadioLangComponent } from './aFormRadioLang/aFormRadioLang.component';
import { AFormRegexComponent } from './aFormRegex/aFormRegex.component';
import { AFormTimeComponent } from './aFormTime/aFormTime.component';

const components=[AFormTextComponent,
AFormTextareaComponent,
AFormYesNoComponent,
AFormPasswordComponent,
AFormEmailComponent,
AFormSelectComponent,
AFormSelectLangComponent,
AFormNumberComponent,
AFormIntegerComponent,
AFormPIntegerComponent,
AFormImgComponent,
AFormFileComponent,
AFormCurrencyComponent,
AFormDateComponent,
AFormRadioComponent,
AFormRegexComponent,
AFormTimeComponent,
AFormRadioLangComponent] ;


@NgModule({
  imports: [FormsModule, TranslateModule, BrowserModule, HttpModule, JsonpModule, RouterModule,DialogModule,CheckboxModule,DataTableModule,SharedModule,DataListModule,RadioButtonModule,CalendarModule],
  declarations: [...components],
  providers: [],
  exports: [DataListModule,DialogModule,CheckboxModule,RadioButtonModule,CalendarModule,RouterModule,DataTableModule,SharedModule, ...components]
})
export class AComponentModule { }




// WEBPACK FOOTER //
// ./src/app/component/aComponent.module.ts